import { LocalizationService } from '@abp/ng.core';
import { PredefinedWrapUpCodeId } from 'src/core/constants/predefined-wrap-up-code-id.constant';

const PREDEFINED_WRAP_UP_CODE_IDS = new Set<number>(Object.values(PredefinedWrapUpCodeId));

export function predefinedWrapUpCodeKey(name: string): string {
  return `Settings::WorkEnvironment:WrapupCodes:Predefined:${name.replace(/\s+/g, '')}`;
}

export function localizePredefinedWrapUpCodeName(
  localization: LocalizationService,
  name: string,
): string {
  const key = predefinedWrapUpCodeKey(name);
  const localized = localization.instant(key);
  return localized === key ? name : localized;
}

export function localizeWrapUpCodeName(
  localization: LocalizationService,
  wrapUpId: number,
  name: string,
): string {
  return PREDEFINED_WRAP_UP_CODE_IDS.has(wrapUpId)
    ? localizePredefinedWrapUpCodeName(localization, name)
    : name;
}
